export default {"src":"/_next/static/media/rocketSix.f7bb0de4.svg","height":25,"width":25};